// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"813":"4fbf423001a6ea10","4896":"84f6640a228a67d3","5259":"fc301960a33d88b1","8199":"a278752707f705af","8460":"f4f39e6edce3f679","9700":"d5f8a49525530ebf"}[chunkId] + ".css";
};